<template>
    <div class="settings">
        <!-- Tab content area -->

        <div class="col-sm-12 o-no-padding c-responsive-fixwidth">

            <div class="col-sm-4 o-right-padding-only">
                <div class="c-common-space c-common-box-shadow c-radius3">
                    <div class="c-user-tab-content clearfix o-skillset-area o-profile-boxAppend">
                        <div class="col-md-12">
                            <h2 class="h2">{{$t('formatting')}}:</h2> 
                        </div>
                        <div class="col-sm-12 o-no-padding o-running-strip o-running-strip--profile">
                            <div class="col-sm-12">
                                <ul class="c-skillset">
                                    <li>
                                        <h6 class="h6">{{ $t('date_format') }}:</h6>
                                        <div class="o-cutsomSelect">
                                            <select v-model="employeeData.date_format" @change="dateSelect()" >
                                                <option v-for="(date,index) in dateFormat" :key="index" :value="date">{{date}}</option>
                                            </select>
                                        </div>
                                        <h6 class="h6 exampleDate">e.g.- {{exampleDate}}</h6>
                                    </li>
                                </ul>
                            </div>
                            <div class="col-sm-12">
                                <ul class="c-skillset">
                                    <li>
                                        <h6 class="h6">{{ $t('time_format') }}:</h6>
                                      <!-- <p class="h5-v2">12 Hour Clock</p> -->
                                      <div class="o-cutsomSelect">
                                           <select v-model="employeeData.time_format" @change="timeSelect()">
                                                <option v-for="(time,index) in timeFormat" :key="index" :value="time">{{time}}</option>
                                            </select>
                                        </div>
                                        <h6 class="h6 exampleDate">e.g.- {{exampleTime}}</h6>
                                    </li>
                                </ul>
                            </div>

                            <!-- <div class="col-sm-6 o-left-padding-only">

                                <ul class="c-skillset">
                                    <li>
                                        <h6 class="h6">Phone format:</h6>
                                        <p class="h5-v2">xxxyyyzzzz</p>
                                    </li>
                                </ul>

                            </div> -->


                        </div>

                    </div>
                </div>
            </div>

            <div class="col-sm-4 o-right-padding-only">
                <div class="c-common-space c-common-box-shadow c-radius3">
                    <div class="c-user-tab-content clearfix o-skillset-area o-profile-boxAppend">
                        <div class="col-md-12">
                            <h2 class="h2">{{ $t('car_pooling') }}</h2>
                            <p class="ps2">{{ $t('car_pooling_info1') + $t('car_pooling_info2') }}</p>
                        </div>
                        <div class="col-sm-12 o-no-padding o-running-strip o-running-strip--profile">
                            <div class="col-sm-12 o-left-padding-only">
                                <ul class="c-skillset">
                                    <li>
                                        <h6 class="h6">{{ $t('carpool') }}:</h6>
                                        <p class="h5-v2">{{ $t('i_cant_provide_transportation') }} </p>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div class="col-md-12">
                            <h2 class="h2">Nylas Calendar Integration [$5/year, A subscription]: <br /> <span class="user-spec">(for Google, Microsoft, and iCloud calendars.)</span></h2>
                            <!-- <p class="ps1">(for Google, Microsoft, and iCloud calendars.)</p> -->
                            <p class="ps2">Synchronize jobs, and changes to confirmed jobs, to your Calendar.
                                ICS files are difficult to maintain and sometimes impossible to deliver.
                                CallSteward has partnered with Nylas to ensure the deliverability and privacy of your calendar events.
                                Please enter the email address associated with your calendar.
                            </p>
                            <p class="ps2">
                                Now all calendars will receive confirmed calls, updates to calls, and deleted calls, usually in under a minute. This is a 3rd Party Integration and we need your permission to subscribe to this service. Please bear in mind that when we ask for your permission, the email requested is for the email connected to your personal calendar, which may be different than your Call Steward email and password. <br />
                                Apple users will be requested to set an 'App Specific Password.'
                                <a href="https://support.callsteward.com/a/solutions/articles/24000036231" class="nilas-privacy-policy" target="_blank">
                                    https://support.callsteward.com/a/solutions
                                </a>
                            </p>
                        </div>
                        <div class="col-sm-12 o-no-padding o-running-strip o-running-strip--profile">                         
                            <div class="col-sm-12 o-left-padding-only" :loading="!dataAvailable">

                                <ul class="c-skillset">
                                    <li>
                                        <div class="col-md-12">
                                            <!-- <stripe-checkout
                                            ref="checkoutRef"
                                            mode="subscription"
                                            :pk="publishableKey"
                                            :line-items="lineItems"
                                            :success-url="successURL"
                                            :cancel-url="cancelURL"
                                            @loading="v => loading = v"
                                            :clientReferenceId="userID"
                                            @token="tokenCreated"
                                            :customerEmail="employeeData.employable && employeeData.employable.email ? employeeData.employable.email : ''"
                                            :customer="stripe_customer_id"
                                            /> -->
                                            <!-- <stripe-checkout
                                                ref="checkoutRef"
                                                :pk="publishableKey"
                                            /> -->
                                            <!-- is_nylas_subscription_active -->
                                            <div class="nylas-cancel-block">
                                                <button class="nylas-refresh-button" v-if="!nylas_subscription&&stripe_subscription" @click="submit">Re-sync</button>
                                                <button v-if="nylas_subscription" class="nylas-cancel-button" @click="cancelSubscription">Cancel</button>
                                                <div class="nylas-subscription-label" v-if="nylas_subscription&&stripe_subscription">Send Event: </div>
                                                <div class="notify-icon" v-if="nylas_subscription&&stripe_subscription">
                                                    <!-- <div class="nylas-subscription-label">Send Event: </div> -->
                                                    <a href="javascript: void(0)" title="Send a Test Notification " class="nylas-event active" @click="sendNylasEvent(employeeData)">
                                                        <img class="nylas-logo" src="static/assets/images/nylas-logo.svg" />
                                                    </a>
                                                </div>
                                            </div>
                                            <div v-if="!nylas_subscription&&!stripe_subscription">
                                                <input v-model="employeeEmail" v-validate="'required|email'" name="email" type="text" class="form-control" placeholder="Email to integrate with Nylas">
                                                <span v-show="errors.has('email')" class="err-msg">{{ errors.first('email') }}</span>
                                                
                                                <!-- <button class="nylas-subscribe-button" @click="submit">Subscribe</button>                                    -->
                                                <button class="nylas-subscribe-button" @click="handleCheckout">Subscribe</button>                                   
                                            </div>
                                        </div>                                        
                                    </li>
                                    <li>
                                        <h6 class="h6">
                                            <a href="https://www.nylas.com/privacy-policy/" class="nilas-privacy-policy" target="_blank">
                                                Check Nylas Privacy Policy
                                            </a>
                                        </h6>
                                    </li>
                                    <li>
                                        <h6 class="h6">
                                            <a href="https://www.callsteward.com/index.php/privacy-policy/" class="nilas-privacy-policy" target="_blank">
                                                Check Callsteward Privacy Policy
                                            </a>
                                        </h6>
                                    </li>
                                </ul>
                            </div>

                        </div>

                    </div>
                </div>
            </div>

            <div class="col-sm-4 o-right-padding-only">
                <div class="c-common-space c-common-box-shadow c-radius3">
                    <div class="c-user-tab-content clearfix o-skillset-area o-profile-boxAppend">
                        <div class="col-md-12">
                            <h2 class="h2">{{ $t('notifications') }}:</h2>
                            <p class="ps2">{{ $t('select_notify_channel') }} </p>
                        </div>
                        <div class="col-sm-12 o-no-padding o-running-strip o-running-strip--profile">
                            <div class="col-sm-12 o-left-padding-only">
                                <ul class="c-skillset c-skillset--profile">

                                    <li>
                                       <div class="radio o-custom-radio">
                                            <!-- <label>
                                                <input type="radio" name="notifyChck" value="app" v-model="pickedNotify" @change="changeNotificationSettings()">
                                                <span class="cr"><i class="cr-icon fa fa-circle"></i></span> {{ $t('app')}}
                                            </label> -->
                                            <el-switch
                                                v-model="notifyApp"
                                                active-color="#13ce66"
                                                inactive-color="#dcdfe6"
                                                :active-value = 1
                                                :inactive-value = 0
                                                @change="changeNotifyToApp()"
                                                >
                                            </el-switch>                                                
                                                {{$t('app') }}
                                        </div>
                                        <!-- <div class="checkbox o-custom-radio">
                                            <label>
                                                APP
                                                <input type="checkbox" name="o4" v-model="employeeData.app_notification" @change="changeAppNotification()">
                                                <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                            </label>
                                        </div> -->
                                    </li>
                                    <li>
                                        <div class="radio o-custom-radio">
                                            <!-- <label>                                               
                                                <input type="radio" name="notifyChck" value="email" v-model="pickedNotify" @change="changeNotificationSettings()">
                                                <span class="cr"><i class="cr-icon fa fa-circle"></i></span> {{ $t('email_primary') }}
                                            </label> -->
                                            <el-switch
                                                v-model="notifyEmail"
                                                active-color="#13ce66"
                                                inactive-color="#dcdfe6"
                                                :active-value = 1
                                                :inactive-value = 0
                                                @change="changeNotifyToEmail()"
                                                >
                                            </el-switch>                                                
                                                {{$t('email_primary') }}
                                        </div>

                                        <!-- <div class="checkbox o-custom-radio">
                                            <label>
                                                Email(primary)
                                                <input type="checkbox" name="o4" v-model="employeeData.email_notification" @change="emailNotificationSettings()">
                                                <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                            </label>
                                        </div> -->

                                    </li>
                                    <li v-if="!isCallstewardUK()">
                                       <div class="radio o-custom-radio">
                                            <!-- <label>
                                                <input type="radio" name="notifyChck" value="sms" v-model="pickedNotify" @change="changeNotificationSettings()">
                                                <span class="cr"><i class="cr-icon fa fa-circle"></i></span> {{ $t('sms_cell')}}
                                            </label> -->
                                            <el-switch
                                                v-model="notifySms"
                                                active-color="#13ce66"
                                                inactive-color="#dcdfe6"
                                                :active-value = 1
                                                :inactive-value = 0
                                                @change="changeNotifyToSms()"
                                                >
                                            </el-switch>                                                
                                                    {{$t('sms_cell') }}
                                        </div>

                                        <!-- <div class="checkbox o-custom-radio">
                                            <label>
                                                SMS(cell)
                                                <input type="checkbox" name="o4" v-model="employeeData.sms_notification" @change="smsNotificationSettings()">
                                                <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                            </label>
                                        </div> -->

                                    </li>
                                </ul>
                            </div>
                            <div class="col-md-12">
                                <h2 class="h2" v-if="isCallstewardUK()">Stop Email:</h2>
                                <h2 class="h2" v-else> {{ $t('stop_email_sms') }}: </h2>
                                <!-- <p class="ps2">Do you want to stop receive email and sms?.</p>
                                <el-switch
                                    v-model="notifyLock"
                                    @change="notifyStartStop()"
                                    style="display: block"
                                    active-color="#13ce66"
                                    inactive-color="#dcdfe6">
                                </el-switch> -->
                            </div>
                            <div class="col-sm-12 o-left-padding-only">
                                <ul class="c-skillset c-skillset--profile">

                                    
                                    <li>
                                        <div class="radio o-custom-radio">
                                            <label>                                               
                                                <input type="radio" name="notifStop" :value="false" v-model="notifyLock" @change="notifyStartStop()">
                                                <span class="cr"><i class="cr-icon fa fa-circle"></i></span> {{ $t('receive') }}
                                            </label>
                                        </div>

                                    </li>
                                    <li>
                                       <div class="radio o-custom-radio">
                                            <label>
                                                <input type="radio" name="notifStop" :value="true" v-model="notifyLock" @change="notifyStartStop()">
                                                <span class="cr"><i class="cr-icon fa fa-circle"></i></span> {{ $t('stop') }}
                                            </label>
                                        </div>

                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div class="col-md-12"> 
                            
                        </div>

                        <!-- <div class="col-md-12" v-if="getLogsAccess()">
                            <div>
                                <h2 class="h2">{{ $t('navigation_history') }}: </h2>
                                <p class="ps2">{{ $t('navigation_notification_note') }} </p>
                            </div>
                            <div class="o-employe-view">
                                <a href="javascript: void(0)" @click="notifyHistory()" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-eye" aria-hidden="true"></i>{{ $t('click_to_view') }} </a>
                            </div>
                        </div> -->

                                <!-- <p class="ps2">{{ $t('navigation_notification_note') }} </p> -->
                        <!-- <div class="col-md-12" v-if="mailing_list_visibility_flag">
                            <div>
                                <h2 class="h2">Announcements from other IATSE Locals: </h2>
                            </div>
                            <div class="o-employe-view">
                                <el-switch
                                    v-model="mailing_action"
                                    active-color="#13ce66"
                                    inactive-color="#dcdfe6"
                                    :active-value = 1
                                    :inactive-value = 0
                                    @change="changeMailingAction()"
                                    >
                                </el-switch>
                                An Email List
                            </div>
                        </div> -->
                    </div>
                </div>
            </div>

            <!-- <div class="col-sm-4 o-right-padding-only">
                <div class="c-common-space c-common-box-shadow c-radius3">
                    <div class="c-user-tab-content clearfix o-skillset-area o-profile-boxAppend">
                        <div class="col-md-12">
                            <h2 class="h2">{{$t('login_options')}}:</h2>
                        </div>
                        <div class="col-sm-12 o-no-padding o-running-strip o-running-strip--profile">
                            <div class="col-sm-12 o-left-padding-only">
                                <ul class="c-skillset c-skillset--profile">

                                    <li>
                                       <div class="radio o-custom-radio">
                                            <label>
                                                <input type="radio" name="twoFactorAuth" :checked="two_factor_auth" @click="changeSignInOptions2fa()">
                                                <span class="cr"><i class="cr-icon fa fa-circle"></i></span> {{ $t('2fa_authentication') }}
                                            </label>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="radio o-custom-radio">
                                            <label>                                               
                                                <input type="radio" name="fingerPrintAuth" :checked="finger_print_auth" @click="changeSignInOptionsFpa()">
                                                <span class="cr"><i class="cr-icon fa fa-circle"></i></span> 
                                                {{ $t('finger_print_authentication') }}
                                                {{ $t('google_ios_authorization') }}
                                            </label>
                                        </div>
                                    </li>
                                    
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->
            <!-- <div class="col-sm-3 o-no-padding">
                <div class="c-common-space c-common-box-shadow c-radius3">
                    <div class="c-user-tab-content clearfix o-skillset-area o-profile-boxAppend">
                        <div class="col-md-12">
                            <h2 class="h2">Notifications:</h2>
                            <p class="ps2">Your .ics calendar file is located at:</p>
                        </div>
                        <div class="col-md-12">
                            <div class="o-employe-view">
                                <a href="#" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-download" aria-hidden="true"></i> Download</a>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <p class="ps2">If shifts are imported incorrectly, try the UTC calendar:</p>
                        </div>
                        <div class="col-md-12">
                            <div class="o-employe-view">
                                <a href="#" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-download" aria-hidden="true"></i> Download</a>
                            </div>
                        </div>

                    </div>
                </div>
            </div> -->

        </div>

        <!-- /Tab content area -->
    </div>
</template>
<script>
    // import { global } from '../../global.js';
    import service from '../../services.js';
    import dateTimeConvert from '../../timeConvert&Compare';
    // import { StripeCheckout } from '@vue-stripe/vue-stripe';
    // import { StripeCheckout } from '@vue-stripe/vue-stripe';
    import { loadStripe } from '@stripe/stripe-js';
    import { mapGetters } from 'vuex';
    // import { bus } from '../../main';

    export default {
        components: {
            // StripeCheckout
        },
        data() {
            return {
                stripe: null,
                stripe_customer_id: '',
                is_nylas_subscription_active: false,
                nylas_subscription: null,
                stripe_subscription: null,
                employeeEmail: '',
                dataAvailable: false,
                lineItems: 
                {
                    price: 'price_1KdwUrJTPH63iEDVOSzQU9ui', // The id of the recurring price you created in your Stripe dashboard
                    quantity: 1
                },
                successURL: window.location.href.split('#')[0]+"#/stripe-success",
                cancelURL: window.location.href,
                loading: false,
                // publishableKey: 'pk_live_51KUWweJTPH63iEDVnKZLaeCLWmgWvyHqU6MZZPjKZ8bb9s5tEt0mEyvyaZIqRowCF5zq08T1qZpm2YTXAKMtlRkr0004NOpe00',4
                publishableKey: 'pk_live_51KUWweJTPH63iEDVkq6vI8gMZmOYLP4M2O9sTH5Ds9MENaPLz9ruxIAAmwFim14eRM8SaySTImPn4DCWaPAd9rGb00ixz52czC',
                able_to_access_logs: null,
                notifyApp: false,
                notifyEmail: false,
                notifySms: false,
                two_factor_auth: false,
                finger_print_auth: false,
                pickedNotify: 'sms',
                notifyLock:true,
                ics_link:'',
                exampleDate: moment(Date.now()).format("DD MMMM YYYY"),
                dateFormat: [
                    "MM-DD-YY",
                    "MM/DD/YYYY",
                    "MMM DD YYYY",
                    "MMMM DD YYYY",
                    "DD-MM-YY",
                    "DD-MM-YYYY",
                    "DD MMM YYYY",
                    "DD MMMM YYYY",
                    "YYYY-MM-DD",
                    "YYYY MMM DD",
                    "YYYY MMMM DD",
                ],
                exampleTime: moment(Date.now()).format("hh:mm a"),
                timeFormat: [
                    "hh:mm a",
                    "HH:mm",
                ],
                selectDate: '',
                selectTime: '',
                employeeData: [],
                mailing_action: false,
                clientData: null,
                mailing_list_visibility_flag: false
            }
        },
        props: {
            // userProfile: {
            //     type: Object,
            //     required: true
            // }
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userRoleSlug: 'userRoleSlug',
                userClientID: 'userClientID',
                employeeId: 'employeeId',
                currentEmployeeID: 'currentEmployeeID',
                // getNotificationType: 'getNotificationType',
                userID: 'userID',
                getNylasUserEmail: 'getNylasUserEmail'
            })
        },
        methods: {
            sendNylasEvent(emp) {
                if(emp.employable.stripe_subscription&&emp.employable.nylas_subscription) {
                    console.log('Nylas Event');
                    service.post('employee/sendNylasTestEvent', { employee_id: emp.id }, {
                        'Authorization': this.userToken
                    })
                    .then((res) => {
                        console.log(res.data);
                        if(res.data.status_code == "1") {
                            this.$notify({
                                title: 'Success',
                                message:res.data.status_message + ' for ' + res.data.result.email_address,
                                type: 'success'
                            });
                        }else {
                            this.$notify({
                                title: 'Error',
                                message:res.data.status_message,
                                type: 'error'
                            });
                        }
                    }).catch((err) => {
                        console.log(err);
                        this.$notify.error({
                        title: 'Error!',
                        message: 'Something went wrong'
                    });

                    });
                }else if(!emp.employable.stripe_subscription&&!emp.employable.nylas_subscription){
                    this.$notify.error({
                        title: 'Error!',
                        message: 'Missing Both Nylas and Stripe Subscriptions'
                    });
                }else if(!emp.employable.nylas_subscription) {
                    this.$notify.error({
                        title: 'Error!',
                        message: 'Missing only Nylas Subscription'
                    });
                }else {
                    this.$notify.error({
                        title: 'Error!',
                        message: 'Missing only Stripe Subscription'
                    });
                }
            },
            async changeMailingAction() {
                let result = this.mailing_action ? 'subscribe' : 'unsubscribe';
                console.log(this.mailing_action, result);
                await service.put('employee/'+ this.userID + '/updateMailingList',{
                    mailing_action: result
                }, {
                    'Authorization': this.userToken
                }).then((res) => {
                    if(res.data) {
                        console.log(res.data);
                        this.$notify.success(
                            {
                                message: res.data.status_message,
                                title: 'Success'
                            }
                        );
                    }       
                }).catch((err) => {
                    console.log(err);
                    this.$notify(
                        {
                            type: 'error',
                            message: 'Something went wrong',
                            title: 'Error'
                        }
                    );
                    
                });
            },
            refreshSubscription() {
                // console.log("Refresh Nylas Subscription");
                this.$notify({
                    type: 'success',
                    title: this.$t('success'),
                    message: 'Nylas Integration Refreshed'
                });
            },

            tokenCreated(token) {
                setTimeout(()=>{
                    // self.cropImg = self.$refs.cropper.getCroppedCanvas().toDataURL();
                    console.log("Token Created ....................",token);
                },1000)

            },

            async submit () {
                // if(this.employeeEmail=='' || this.errors.has('email')) {
                //     this.$notify.error({
                //         message: "Valid Email is required to proceed",
                //         title: "Required"
                //     });
                //     return;
                // }
                // this.$store.dispatch('setNylasUserEmail', this.employeeEmail);
                // console.log(this.getNylasUserEmail);
                if(this.employeeData.employable.stripe_subscription) {
                    // You will be redirected to Nylas's integration page
                    await this.generateNylasLink();
                    // await this.getEmailProvider();
                } 
            },

            async handleCheckout() {
                this.loading = true;
                if(this.employeeEmail=='' || this.errors.has('email')) {
                    this.$notify.error({
                        message: "Valid Email is required to proceed",
                        title: "Required"
                    });
                    return;
                }
                this.$store.dispatch('setNylasUserEmail', this.employeeEmail);
                console.log(this.employeeData);
                if(this.employeeData&&this.employeeData.employable&&this.employeeData.employable.stripe_subscription) {
                    // You will be redirected to Nylas's integration page
                    await this.generateNylasLink();
                    // await this.getEmailProvider();
                }else {
                    try {
                        let headers = { 
                            'authorization': this.userToken
                        }
                        let body = {
                            // userId: this.userID, // Pass user-related data here
                            line_items: {
                                price: 'price_1KdwUrJTPH63iEDVOSzQU9ui', // The id of the recurring price you created in your Stripe dashboard
                                quantity: 1
                            },
                            success_url: this.successURL,
                            cancel_url: this.cancelURL,
                            customer_id: this.stripe_customer_id,
                            client_reference_id: this.userID
                        }
                        console.log("Body: ......................", body);
                        const response = await service.post('employee/create-stripe-session', body, headers );
                        // console.log("Session ID: ......................", response.data);
                        const { sessionId } = response.data;
                        const { error } = await this.stripe.redirectToCheckout({ sessionId });
                        if (error) console.error('Stripe Checkout Error:', error);
                    } catch (error) {
                        console.error("Error during checkout:", error);
                    } finally {
                        this.loading = false;
                    }
                }
            },

            async getEmailProvider() {
                await service.get('employee/detectNylasProvider', {
                    'Authorization': this.userToken,
                    'email': this.getNylasUserEmail
                }).then(async(res) => {
                    if(res.data&&res.data.result&&res.data.result=='gmail') {  
                        this.$router.push({
                            path: "/sign-in-with-google",
                            name: 'signInWithGoogle'
                        });
                    }else {
                        await this.generateNylasLink();
                    }        
                }).catch((err) => {
                    console.log(err);
                });
            },

            async cancelSubscription() {
                this.$confirm('Are you sure you would like to cancel the Subscription? ', 'Warning', {
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    type: 'warning'
                }).then(async() => {
                    // Cancel Stripe Subscription
                    await this.cancelStripeSubscription();

                    // Cancel Nylas Subscription
                    await this.cancelNylasSubscription();
                   
                    
                }).catch((error) => {
                    console.log(error);
                    this.getEmpDetails();
                });
            },

            async cancelNylasSubscription() {
                await service.post('employee/cancelNylasSubscription',{
                user_id: this.userID
                }, {
                    'Authorization': this.userToken
                }).then(async(res) => {
                    // console.log(res.data);
                    // this.getEmpDetails();
                    if(res.data) {                   
                        this.$notify({
                            type: 'success',
                            title: this.$t('success'),
                            message: res.data.status_message
                        });
                    }
                    await this.getEmpDetails();
                    this.dataAvailable = true;
                }).catch((err) => {
                    console.log(err);
                });
            },

            async cancelStripeSubscription() {
                this.dataAvailable = false;
                    await service.post('employee/cancelStripeSubscription',{
                    user_id: this.userID
                    }, {
                        'Authorization': this.userToken
                    }).then((res) => {
                        // console.log(res.data);
                        // this.getEmpDetails();
                        if(res.data) {                   
                            this.$notify({
                                type: 'success',
                                title: this.$t('success'),
                                message: res.data.status_message
                            });
                        }
                    }).catch((err) => {
                        console.log(err);
                    });
            },
            
            async generateNylasLink() {
                await service.get('employee/authorizeNylas', {
                    'Authorization': this.userToken,
                    'user-id': this.userID,
                    'email': this.getNylasUserEmail
                }).then((res) => {
                    if(res.data&&res.data.result) {                        
                        window.location.href = res.data.result;
                        this.$notify({
                            type: 'success',
                            title: this.$t('success'),
                            message: 'Nylas Subscription Started. Thank you for being with us!'
                        });
                    }                    
                }).catch((err) => {
                    console.log(err);
                });
            },

            getLogsAccess(){
                if(this.able_to_access_logs || this.userRoleSlug != 'employee'){
                    return true;
                }
                return false;
            },

            isCallstewardUK(){
                return dateTimeConvert.isCallstewardUK();
            },

            notifyStartStop(){
                var formData ={
                    'employee_id': this.employeeData.id,
                    'status': this.notifyLock
                };
                // console.log(formData);
                
                service.post('employee/stopNotificationSettings', formData, {
                    'Authorization': this.userToken,
                    'ClientId': this.userClientID
                }).then((res) => {
                    this.$message({
                        type: 'success',
                        message: 'Success.'
                    });
                }).catch((err) => {
                    console.log(err);
                });
            },

            notifyHistory(){
                this.$store.dispatch('setNotificationType', 'employeeHistoryAction');
                this.$router.push({
                    path: `/notifyLog/`+ btoa(this.employeeData.id)
                });
            },

            dateSelect() {
                var formData = {
                    'employee_id': this.employeeData.id,
                    'type': 'date',
                    'format_string': this.employeeData.date_format
                }
                this.exampleDate = moment(Date.now()).format(this.employeeData.date_format);
                service.post('employee/changeDateFormat', formData, {
                    'Authorization': this.userToken,

                    'ClientId': this.userClientID
                }).then((res) => {
                    //console.log(res);
                    this.$cookies.set("date_format", this.employeeData.date_format, "23h");
                }).catch((err) => {
                    console.log(err);
                });

            },

            generateLink(){
                service.get('call/calendar/'+this.employeeData.id, {
                    'Authorization': this.userToken,
                    'ClientId': this.userClientID
                }).then((res) => {
                    //console.log(res.data.result.calendar_file);
                    this.ics_link=res.data.result.calendar_file;
                    
                }).catch((err) => {
                    console.log(err);
                    this.$message({
                        type: 'error',
                        message: 'File not found. '
                    });
                });
            },

            timeSelect() {
                var formData = {
                    'employee_id': this.employeeData.id,
                    'type': 'time',
                    'format_string': this.employeeData.time_format
                }
                this.exampleTime = moment(Date.now()).format(this.employeeData.time_format);
                service.post('employee/changeDateFormat', formData, {
                    'Authorization': this.userToken,
                    'ClientId': this.userClientID
                }).then((res) => {
                    //console.log(res);
                    this.$cookies.set("time_format", this.employeeData.time_format, "23h");
                }).catch((err) => {
                    console.log(err);
                });
            },

            changeNotificationSettings(){
                // console.log(this.pickedNotify);
                // if(this.pickedNotify=='email'){
                //     this.emailNotificationSettings();
                // }else{
                //     this.smsNotificationSettings();
                // }
                this.emailNotificationSettings();
                this.smsNotificationSettings();
                this.changeAppNotification();
                this.$store.dispatch('setNotificationType', this.pickedNotify);
            },

            changeNotifyToApp() {
                if(this.notifyApp == 0 && this.notifyEmail == 0 && this.notifySms == 0){
                    this.$notify.error({
                        message: 'Notification must have at least one active channel',
                        title: this.$t('warning')
                    })
                    this.notifyApp = 1
                    return;
                } else {
                    var formData = {
                        'status': this.notifyApp,
                        'employee_id': this.employeeData.id
                    };
                    service.post('employee/appNotificationSettings', formData, {
                        'Authorization': this.userToken,
                        'ClientId': this.userClientID
                    }).then((res) => {
                        this.$notify.success({
                            message: 'Notification channel updated',
                            title: this.$t('success')
                        })
                        //console.log(res);
                    }).catch((err) => {
                        console.log(err);
                    });
                }
            },
            // emailNotificationSettings() {
            changeNotifyToEmail() {
                if(this.notifyApp == 0 && this.notifyEmail == 0 && this.notifySms == 0){
                    this.$notify.error({
                        message: 'Notification must have at least one active channel',
                        title: this.$t('warning')
                    })
                    this.notifyEmail = 1
                    return;
                } else {
                    var formData = {
                        'status': this.notifyEmail,
                        'employee_id': this.employeeData.id
                    };
                    service.post('employee/emailNotificationSettings', formData, {
                        'Authorization': this.userToken,
                        'ClientId': this.userClientID
                    }).then((res) => {
                        this.$notify.success({
                            message: 'Notification channel updated',
                            title: this.$t('success')
                        })
                        //console.log(res); 
                        //bus.$emit('onUpdateOrAdd', 'On update notifications settings');
                    }).catch((err) => {
                        console.log(err);
                    });
                }
            },
            // smsNotificationSettings() {
            changeNotifyToSms() {
                if(this.notifyApp == 0 && this.notifyEmail == 0 && this.notifySms == 0){
                    this.$notify.error({
                        message: 'Notification must have at least one active channel',
                        title: this.$t('warning')
                    })
                    this.notifySms = 1
                    return;
                } else {
                    // console.log("Sms Notify Else")
                    var formData = {
                        'status': this.notifySms,
                        'employee_id': this.employeeData.id
                    };
                    service.post('employee/smsNotificationSettings', formData, {
                        'Authorization': this.userToken,
                        'ClientId': this.userClientID
                    }).then((res) => {
                        this.$notify.success({
                            message: 'Notification channel updated',
                            title: this.$t('success')
                        })
                    }).catch((err) => {
                        console.log(err);
                    });
                }
            },

            changeSignInOptions2fa() {
                this.two_factor_auth = !this.two_factor_auth;

                var formData = {
                    'status': this.two_factor_auth ? 1 : 0,
                    'user_id': this.employeeData.employable.id
                };

                service.post('employee/twoFactorAuthSettings', formData, {
                    'Authorization': this.userToken,
                }).then((res) => {
                    this.$notify({
                        title: 'Success',
                        message: 'Login Option Updated',
                        type: 'success'
                    });
                }).catch((err) => {
                    this.$notify({
                        title: 'Error',
                        message: 'Something went Wrong',
                        type: 'error'
                    });
                    console.log(err);
                });
            },

            changeSignInOptionsFpa() {
                this.finger_print_auth = !this.finger_print_auth;
                // var formData = {
                //     'status': this.finger_print_auth ? 1 : 0,
                //     'user_id': this.employeeData.employable.id
                // };
                // console.log(formData);
            },
            
            async getEmpDetails() {
                // this.getBaseURL = global[0].IMAGE_URL;
                this.$Progress.start();
                await service.get('employee/' + this.employeeId, {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID
                    })
                    .then((res) => {
                        //this.employeeData = basic.data.result;
                        this.employeeData = res.data.result;
                        console.log("Employee: ....................",this.employeeData);
                        this.nylas_subscription = this.employeeData&&this.employeeData.employable&&this.employeeData.employable.nylas_subscription?this.employeeData.employable.nylas_subscription:null;
                        this.stripe_subscription = this.employeeData&&this.employeeData.employable&&this.employeeData.employable.stripe_subscription?this.employeeData.employable.stripe_subscription:null;

                        this.is_nylas_subscription_active=this.nylas_subscription?this.nylas_subscription.is_active:false;

                        this.employeeEmail = this.nylas_subscription && this.nylas_subscription.email_address ? this.nylas_subscription.email_address:'';

                        this.dataAvailable = true;
                        this.$forceUpdate();
                        // this.userImage = this.detailEmployee.employable;
                    }).catch((err) => {
                        console.log(err);
                    });
            },

            getMailingListStatus() {
                service.get('employee/'+ this.userID +'/checkUserSubscriptionStatus', {
                    'Authorization': this.userToken,
                })
                .then((res) => {
                    this.mailing_action=res.data;
                    console.log(res.data);
                    // this.getSettings();
                }).catch((err) => {
                    console.log(err);
                });
            },

            async getClientData() {
                await service.get('client/' + this.userClientID, {
                'Authorization': this.userToken
                })
                .then((res) => {
                    this.clientData = res.data.result;
                    this.mailing_list_visibility_flag = this.clientData.mailing_list_visibility_flag;
                }).catch((err) => {
                    console.log(err);
                });
            },
        },
        
        async created() {
            await this.getEmpDetails();
            await this.getClientData();
            this.stripe_customer_id = this.employeeData && this.employeeData.employable && this.employeeData.employable.stripe_customer_id ? this.employeeData.employable.stripe_customer_id : null;
            // this.stripe_customer_id = 'cus_RPU0rkZbxWXnVx';
            console.log("Stripe Customer Id ..............................",this.stripe_customer_id);
            this.stripe = await loadStripe(this.publishableKey);
            // this.employeeData = this.userProfile;
            this.able_to_access_logs = this.employeeData.employee_status.able_to_access_logs;
            // this.pickedNotify = (this.employeeData.email_notification==1)? 'email':(this.employeeData.sms_notification==1)?'sms':(this.employeeData.app_notification==1)?'app':'';
            this.notifyApp = this.employeeData.app_notification
            this.notifyEmail = this.employeeData.email_notification
            this.notifySms = this.employeeData.sms_notification
            this.two_factor_auth = this.employeeData.employable.two_factor_auth ? true : false;
            this.notifyLock=(this.employeeData.stop_notification==0)?false:true;   
            this.getMailingListStatus();
            console.log(".Com Server - Desk - User Profile Settings Component - Pipeline Check - : 2025/03/26 16:15 IST");
        }
    }

</script>
<style scoped>
.notify-icon {
    margin:10px 10px 10px 0;
}
.nylas-logo {
    height: 25px;
    width: 60px;
    padding: 8px 5px 0;
}
.nylas-event {
    font-size: 16px;        
    border-radius: 5px;
    text-decoration: none!important;
    padding: 12px 10px 5px;
    /* color: #8158b8!important;        
    border: 1px solid #8158b8; */
}
.nylas-event.active {       
    background-color: #8158b8!important;        
    border: 1px solid #8158b8;
}
.nylas-event.active:hover {       
    color: #8158b8!important;        
    border: 1px solid #8158b8;
}

.user-spec {
    font-size: 14px;
    /* color: #3a89ce; */
    margin: 0;
    padding: 0;
}
.nylas-subscribe-button {
    margin: 15px 10px 10px 0;
    padding: 10px 20px;
    border: none;
    outline: none;
    background-color: #258325;
    color: #ffffff;
    font-size:13px;
    font-weight: bold;
    border-radius: 5px;
}
.nylas-cancel-block {
    /* margin: 15px 10px 10px 0; */
    display: flex;
    align-items: start;
    flex-direction: row;
}
.nylas-subscription-label{
    padding: 6px 5px 10px 20px;
    margin-top: 10px;
    /* margin-bottom: 10px; */
    border: none;
    outline: none;
    background-color: #ffffff;
    color: #1f1e1e;
    font-size: 13px;
    font-weight: bold;
}
.nylas-cancel-button {
    padding: 10px 20px;
    margin: 10px;
    border: none;
    outline: none;
    background-color: #e7eee7;
    color: #1f1e1e;
    font-size: 13px;
    font-weight: bold;
    border-radius: 5px;
}
.nylas-refresh-button {
    /* margin: 15px 10px 10px 0; */
    margin: 10px;
    padding: 10px 20px;
    border: none;
    outline: none;
    background-color: #FB9803;
    color: #ffffff;
    font-size: 13px;
    font-weight: bold;
    border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/userProfile/settings.vue